import { render, staticRenderFns } from "./TableItemsCount.vue?vue&type=template&id=6848e54a&scoped=true&functional=true"
import script from "./TableItemsCount.vue?vue&type=script&lang=js"
export * from "./TableItemsCount.vue?vue&type=script&lang=js"
import style0 from "./TableItemsCount.vue?vue&type=style&index=0&id=6848e54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6848e54a",
  null
  
)

export default component.exports